import React,{Component, Fragment} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Dialog from '../../commonModules/interface/Dialog';
import InputText from '../../commonModules/interface/form-input-inline';

import { getRecoveryList, getPaygClients, getSelectedPaygInfo } from '../../../../../jsx/actions/clientAction';
import { getCustomRecoveryList } from '../../../../../jsx/actions/recoveryAction';

import Spin from '../../commonModules/interface/Spin';
import Notif from '../../commonModules/interface/Notif';
import regexp from 'node-regexp';
import PaygPopupInfo from './paygPopupInfo';
import Alerts from './Recovery/Alerts';
import Insolvables from './Recovery/Insolvables';
import RecoveryStats from './Recovery/RecoveryStats';
import { TableRow, TableCell, Box, TableHead, TableBody, Card, AppBar, Tabs, Tab, CircularProgress } from '@material-ui/core';
import CardPage from '../../commonModules/layouts/CardPage';
import { TableLayout } from './Stock/containers/Layout';
import TableFooterPagination from '../../commonModules/interface/TableFooterPagination';
import { Skeleton } from '@material-ui/lab';

const bgColor = {
    Comment: "info",
    Call: "info",
    // Done: "",
    End: "danger",
    Alert:"warning"
    // Alert:"active"

}
class Recovery extends Component{
    state = {
        popUp:false,
        headerMenu: "CLIENTS",
        subHeaderMenu: "LATE",
        clients: null,
        clientsAll: null,
        clients2: null,
        clients2All: null,
        currentClient:{
            userID: "",
            paygoID: "",
            boxAssoId: "",
        },
        idBox:'sorting',
        clientName:'sorting',
        paymentDelay:'sorting_desc',
        lastActionRecoveryDate:'sorting',
        lastPayment:'sorting',
        search:"",
        LATE: [],
        ALMOST_LATE: [],
        loading: true,
        currentPage: 0,
        rowsPerPage:20,

    }

    componentDidMount = async () => {
        if (this.props.show) {
            this.setState({headerMenu: this.props.show})
        }
        if(!this.props.STATE.paygClients.fetched){
            await this.props.getPaygClients()
         }
        await this.getClientList()
    }
    getClientList = async (type = this.state.subHeaderMenu) => {
        console.log("START getClientList");
        if(this.props[type].length === 0){
            await this.props.getRecoveryList(type)
        }
        this.searchFilter()
        this.setState({ loading: false})
    }
        
    displayClientList = () => {
        const { CLIENTS, CLASSES, STATE } = this.props;
        const { currentPage, rowsPerPage } = this.state;
        let list = this.state[this.state.subHeaderMenu]
        // console.log("START displayClientList", {list});
        if(list.length < 1) {
            return
        }
        
        let fetchInfoFor = list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).filter(boxAssoId => !CLIENTS[boxAssoId].resume.recovery_info ).map(boxAssoId => CLIENTS[boxAssoId].resume.boxAssoId)
        console.log('====================================');
        console.log({list, fetchInfoFor});
        console.log('====================================');

        if (!isEmpty(fetchInfoFor)  && !STATE.paygClients.fetching ){
            this.props.getSelectedPaygInfo("recovery", fetchInfoFor, "recovery_info")
        }

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( ID => {
            let client = CLIENTS[ID].resume
            let delay = (client.paymentDelay) * -1
            let bgm = bgColor[client.lastRecoveryActionType]
            return(
                <TableRow 
                    hover 
                    key={client.idBox} 
                    className={bgm || ""} 
                    onClick={() => this.setState({
                        currentClient: {
                            userID: client.userID,
                            paygoID: client.idBox,
                            boxAssoId: client.boxAssoId,
                        }, 
                        popUp:true})
                    }
                >
                    <TableCell>{client.idBox}</TableCell>
                    <TableCell>{client.clientName}</TableCell>
                    <TableCell>{!client.recovery_info ? <Skeleton /> : delay}</TableCell>
                    <TableCell>{!client.recovery_info ? <Skeleton /> : Math.round((client.totalPayed /client.totalToPay )*100)} %</TableCell>
                    <TableCell>{!client.recovery_info ? <Skeleton /> : new Date(client.lastPayment).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell>{!client.recovery_info ? <Skeleton /> : new Date(client.lastActionRecoveryDate).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell>{!client.recovery_info ? <Skeleton /> : client.lastRecoveryActionType}</TableCell>
                </TableRow>
            )
        })
    }
            
    sortByDate = (field) => {
        let list = this.state[this.state.subHeaderMenu]
        const { CLIENTS } = this.props;
        console.log("SORT BY DATE", {field});
        let newSortValue = 'sorting_desc'
        if(this.state[field] === "sorting_desc"){
            newSortValue = 'sorting_asc'

            list.sort((a, b) => {
                
                a = new Date(CLIENTS[a].resume[field]);
                b = new Date(CLIENTS[b].resume[field]);
                if (a > b){
                    return -1;
                }
                if (a < b){
                    return 1;
                }
                return 0;
            });

        } else if (this.state[field] === 'sorting' || this.state[field] === 'sorting_asc'){
            list.sort((a, b) => {
                a = new Date(CLIENTS[a].resume[field]);
                b = new Date(CLIENTS[b].resume[field]);
                if (a > b){
                    return 1;
                }
                if (a < b){
                    return -1;
                }
                return 0;
            });
        }
        this.setState({
            idBox:'sorting',
            clientName:'sorting',
            paymentDelay:'sorting',
            lastPayment:'sorting',
            lastActionRecoveryDate:'sorting',
            [field]:newSortValue,
            [this.state.subHeaderMenu]:list
        })
    }
    sortBy = (field) => {
        const { CLIENTS } = this.props;
        let list = this.state[this.state.subHeaderMenu]

        console.log("START SORT BY", {field});
        let newSortValue = 'sorting_desc'
        if(this.state[field] === "sorting_desc"){
            newSortValue = 'sorting_asc'

            list.sort((a, b) => {
                let fieldA = CLIENTS[a].resume[field]
                let fieldB = CLIENTS[b].resume[field]
                a = typeof fieldA === 'string' ? fieldA.toUpperCase() : fieldA;
                b = typeof fieldB === 'string' ? fieldB.toUpperCase() : fieldB;
                if (a > b){
                    return -1;
                }
                if (a < b){
                    return 1;
                }
                return 0;
            });

        } else if (this.state[field] === 'sorting' || this.state[field] === 'sorting_asc'){
            list.sort((a, b) => {
                let fieldA = CLIENTS[a].resume[field]
                let fieldB = CLIENTS[b].resume[field]

                a = typeof fieldA === 'string' ? fieldA.toUpperCase() : fieldA;
                b = typeof fieldB === 'string' ? fieldB.toUpperCase() : fieldB;
                if (a > b){
                    return 1;
                }
                if (a < b){
                    return -1;
                }
                return 0;
            });
        }
        
        this.setState({
            idBox:'sorting',
            clientName:'sorting',
            paymentDelay:'sorting',
            lastPayment:'sorting',
            lastActionRecoveryDate:'sorting',
            [field]:newSortValue,
            [this.state.subHeaderMenu]:list
        })
    }
    searchFilter = (e) => {
        const { ALMOST_LATE, LATE, CLIENTS} = this.props;
        let list = this.state.subHeaderMenu === "LATE" ? LATE : ALMOST_LATE

        let newList = [];
        let match =  e ? e.target.value : this.state.search
        // console.log('====================================');
        // console.log({match, list});
        // console.log('====================================');
        if(match){
            // console.log('==============MATCH=================');
            
            let re = regexp().must(match).ignoreCase().toRegExp()
            
            list.forEach((ID) => {
                let client = CLIENTS[ID].resume
                if (re.test(client.idBox) || re.test(client.lastRecoveryActionType) || re.test(client.clientName)) {
                    newList.push(ID);
                }
            })
            this.setState({[this.state.subHeaderMenu]: newList, search: match})
        } else {
            // console.log('============NOT==MATCH=================', this.state.subHeaderMenu, "==> ",list);
            this.setState({[this.state.subHeaderMenu]: list, search: match})

        }
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }
    
    render(){
        console.log("recovery STATE", this.state);
        console.log("recovery PROPS", this.props);
        return(
            <CardPage title="Liste des Recouvrements" subtitle="Liste des Clients en retard de Paiement">    
                {this.state.popUp &&
                    <PaygPopupInfo 
                        boxAssoId={this.state.currentClient.boxAssoId}
                        closePopup={()=>this.setState({popUp:false})}
                        USER_INFO_LIST = {["USER", "OTHER"]}
                        // BOX_INFO_LIST = {["INSTALLS", "BOX", "SYSTEM"]}
                        PAYMENTS_INFO_LIST = {["RESUME", "LIST"]} 
                        SUIVI_INFO_LIST
                        recovery 
                        default_tab = {"SUIVI"}
                    />
                }
                <Card>
                    <AppBar position="static">
                        <Tabs
                            value={this.state.headerMenu}
                            onChange={(e, headerMenu) => this.setState({ headerMenu })}
                            indicatorColor="secondary"
                            // textColor="secondary"
                            variant="fullWidth"
                            scrollButtons="auto"
                        >
                            <Tab value="DASHBOARD" label="Dashboard" />
                            <Tab value="CLIENTS" label="Clients" />
                            <Tab value="ALERTS" label="Alertes" />
                            <Tab value="INSOLVABLES" label="Insolvables" />
                        
                        </Tabs>
                    </AppBar>
                    <Box p={2}>
                        { this.state.headerMenu === "DASHBOARD" &&
                            <Box style={{height: '600px', overflow: 'auto'}}>
                                <RecoveryStats />
                            </Box>
                        }
                        { this.state.headerMenu === "CLIENTS" &&
                        <Box>
                            {this.state.loading ? (
                                <Box style={{textAlign: "center"}}>
                                    <CircularProgress color="primary" />
                                </Box>
                            ) : (

                                <Box>
                                    <Tabs
                                        value={this.state.subHeaderMenu}
                                        onChange={(e, subHeaderMenu) => { this.setState({ subHeaderMenu, loading:true }); this.getClientList(subHeaderMenu) }}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                        scrollButtons="auto"
                                    >
                                        <Tab value="LATE" label="En retard" />
                                        <Tab value="ALMOST_LATE" label="Coupure dans 5 jours" />
                                    
                                    </Tabs>     
                                    <Box>                      
                                        <Box p={1}>
                                            <InputText type="text" placeholder="Search" onChange={this.searchFilter} label="Rechercher" />
                                        </Box>
                                        <Box p={2}>
                                            <TableLayout>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" className={this.state.idBox} onClick={()=>this.sortBy('idBox')}>ID</TableCell>
                                                        <TableCell component="th" className={this.state.clientName} onClick={()=>this.sortBy('clientName')} >Nom</TableCell>
                                                        <TableCell component="th" className={this.state.paymentDelay} 
                                                            onClick={()=>this.sortBy('paymentDelay')}>
                                                            Jours de Retard
                                                        </TableCell>
                                                        <TableCell component="th" className="" >Montant Payé</TableCell>
                                                        <TableCell component="th" className={this.state.lastPayment} onClick={()=>this.sortByDate('lastPayment')}>Dernier Paiement</TableCell>
                                                        <TableCell component="th" className={this.state.lastActionRecoveryDate} 
                                                            onClick={()=>this.sortBy('lastActionRecoveryDate')}>
                                                            Date Dernière Action
                                                        </TableCell>
                                                        <TableCell component="th">Dernière Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.displayClientList()}
                                                </TableBody>
                                                <TableFooterPagination
                                                    colSpan={7}
                                                    items={this.state[this.state.subHeaderMenu]} 
                                                    onChangePage={this.onChangePage} 
                                                    initialPage={this.state.currentPage} 
                                                />
                                            </TableLayout>

                                        </Box>
                                    </Box>
                                </Box>
                            ) }
                            </Box>
                        }
                        { this.state.headerMenu === "ALERTS" &&
                        <Box style={{maxHeight: '900px', overflow: 'auto'}}>
                            <Alerts {...this.props}/>
                        </Box>
                        }
                        { this.state.headerMenu === "INSOLVABLES" &&
                        <Box style={{maxHeight: '900px', overflow: 'auto'}}>
                            <Insolvables {...this.props} />
                        </Box>
                        }                        
                    </Box>

				</Card>
            </CardPage>
            
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
        CLIENTS: state.clients,
        STATE: state.inventory.requestState,
        LATE: state.recovery.LATE,
        ALMOST_LATE: state.recovery.ALMOST_LATE,
        ALERTS: state.recovery.ALERTS,
        ENDS: state.recovery.ENDS,
        
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        getRecoveryList,
        getPaygClients,
        getSelectedPaygInfo,
        getCustomRecoveryList,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(Recovery);